import moment from 'moment'

export function getDateTimeFormats () {
  return ['YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD HH:mm', 'YYYY.MM.DD HH:mm:ss', 'YYYY.MM.DD HH:mm', moment.ISO_8601]
}

export function hasExplicitOffset (dateTime) {
  return /(?:Z|[+-]\d{2}:?\d{2})$/i.test(String(dateTime || ''))
}

export function getKstMoment (dateTime) {
  return moment(dateTime, getDateTimeFormats())
}

export function getLocalMomentFromKst (dateTime) {
  if (hasExplicitOffset(dateTime)) {
    return moment.parseZone(dateTime, getDateTimeFormats()).local()
  }
  return moment.utc(dateTime, getDateTimeFormats()).subtract(9, 'hours').local()
}

export function formatKstToLocal (dateTime) {
  if (!dateTime) return ''
  let localTime = getLocalMomentFromKst(dateTime)
  return localTime.isValid() ? localTime.format('YYYY-MM-DD HH:mm:ss') : dateTime
}



// WEBPACK FOOTER //
// ./src/util/timezone.js